var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTubeRoundedColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2723 6.73804H6.72761C6.46606 6.73804 6.20708 6.78957 5.96546 6.8897C5.72384 6.98983 5.50432 7.13659 5.31944 7.32159C5.13456 7.50659 4.98795 7.72621 4.88798 7.9679C4.78801 8.20958 4.73664 8.4686 4.73682 8.73014V12.2696C4.73664 12.5312 4.78801 12.7902 4.88798 13.0319C4.98795 13.2735 5.13456 13.4932 5.31944 13.6782C5.50432 13.8632 5.72384 14.0099 5.96546 14.1101C6.20708 14.2102 6.46606 14.2617 6.72761 14.2617H13.2723C13.5339 14.2617 13.7929 14.2102 14.0345 14.1101C14.2761 14.0099 14.4956 13.8632 14.6805 13.6782C14.8654 13.4932 15.012 13.2735 15.112 13.0319C15.2119 12.7902 15.2633 12.5312 15.2631 12.2696V8.73014C15.2633 8.4686 15.2119 8.20958 15.112 7.9679C15.012 7.72621 14.8654 7.50659 14.6805 7.32159C14.4956 7.13659 14.2761 6.98983 14.0345 6.8897C13.7929 6.78957 13.5339 6.73804 13.2723 6.73804ZM8.61313 12.113V8.88672L11.3868 10.4999L8.61313 12.113Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeRoundedColor);
export default __webpack_public_path__ + "static/media/YouTubeRoundedColor.c1f31c4d3e722df829fe946dc248f9da.svg";
export { ForwardRef as ReactComponent };